import { Flex, Image, Text } from "@chakra-ui/react";
import pcDownload from "assets/images/svgs/pc-download.svg";
import PrimaryButton from "components/Button/PrimaryButton";

export default function FormDownload({
  handleSave,
}: {
  handleSave: () => any;
}) {
  return (
    <Flex
      flexDir="column"
      align="center"
      gap={6}
      m="auto"
      h="500px"
      justify="center"
    >
      <Image src={pcDownload} />
      <Text fontWeight="bold">
        Pronto! Os seus arquivos já estão prontos para serem exportados.
      </Text>
      <PrimaryButton onClick={handleSave}>
        Fazer download da exportação contábil
      </PrimaryButton>
    </Flex>
  );
}
